import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthenticatedUserMenuContent } from '@/components/header/user-actions/user-menu';
import AuthStepShell from '../auth-step-shell';

interface AccountStepProps {
    onNavigate: () => void;
}

export default function AccountStep({ onNavigate }: AccountStepProps): ReactElement {
    const { t: tAccount } = useTranslation('account');

    return (
        <AuthStepShell
            heading={tAccount('myAccount', { defaultValue: 'My Account' })}
            showLogo={false}
            headingAlign="start">
            <AuthenticatedUserMenuContent onItemClick={onNavigate} />
        </AuthStepShell>
    );
}
